import { useEffect, useState } from 'react'
import Loader from '../Loader'
import AutoplanLogoBlue from '../../icons/AutoplanLogoBlue'

const SHELL_TIMEOUT = 15000

const AppLoader = () => {
  const [timedOut, timedOutSet] = useState(false)

  useEffect(() => {
    const timer = setTimeout(() => timedOutSet(true), SHELL_TIMEOUT)
    return () => clearTimeout(timer)
  }, [])

  if (timedOut) {
    return (
      <div className="fixed inset-0 w-screen h-screen bg-grayLight flex flex-col items-center justify-center gap-8 px-6">
        <div className="w-[160px] [&>svg]:w-full [&>svg]:h-auto">
          <AutoplanLogoBlue />
        </div>
        <div className="flex flex-col items-center gap-2 text-center">
          <h1 className="text-xl font-semibold text-primaryText">Vi klarte ikke laste inn portalen.</h1>
          <p className="text-base text-secondaryText">
            Prøv igjen om litt. Hjelper det ikke, kan du logge ut og logge inn på nytt.
          </p>
        </div>
        <div className="flex flex-col sm:flex-row items-center gap-4">
          <button
            type="button"
            className="flex text-base font-semibold items-center justify-center px-5 py-3 rounded-sm w-fit min-w-[125px] text-white bg-primaryBlue hover:bg-secondaryBlue cursor-pointer"
            onClick={() => window.location.reload()}
          >
            Prøv igjen
          </button>
          <a
            href="/logout"
            className="flex text-base font-semibold items-center justify-center px-5 py-3 rounded-sm w-fit min-w-[125px] text-interaction hover:text-interactionHover hover:underline"
          >
            Logg ut
          </a>
        </div>
      </div>
    )
  }

  return <Loader />
}

export default AppLoader
